<template>
  <div class="content-section">
    <!-- Form Section -->
    <div class="form-section">
      <el-form
        ref="form"
        :model="formData"
        :rules="rules"
        :disabled="disabled"
        size="small"
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
              :label="$l('form_label_originOrderNo') || '源头订单号'"
              prop="originOrderNo"
            >
              <el-input
                v-model="formData.originOrderNo"
                clearable
                maxlength="100"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$l('form_label_scmName') || '供方'"
              prop="scmCode"
            >
              <dict-select
                v-model="formData.scmCode"
                url="/master/common/dict/scmPartners"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                clearable
                filterable
                :selectedLabel.sync="formData.scmName"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$l('form_label_purchaserEntityCode') || '需方'"
              prop="purchaserEntityCode"
            >
              <dict-select
                v-model="formData.purchaserEntityCode"
                url="/master/common/dict/biz"
                :body="{ dictType: 'orderSource' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                clearable
                filterable
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_signPlace') || '签订地点'"
              prop="signPlace"
            >
              <el-input
                v-model="formData.signPlace"
                clearable
                maxlength="200"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_totalAmount') || '采购金额'"
              prop="totalAmount"
            >
              <el-input
                v-model="formData.totalAmount"
                controls-position="right"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_buyerName') || '采购人员'"
              prop="buyerCode"
            >
              <dict-select
                v-model="formData.buyerCode"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                clearable
                filterable
                :selectedLabel.sync="formData.buyerName"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_purchaseDate') || '制单日期'"
              prop="purchaseDate"
            >
              <el-date-picker
                v-model="formData.purchaseDate"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_reviewByName') || '审核人员'"
              prop="reviewBy"
            >
              <dict-select
                v-model="formData.reviewBy"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                clearable
                filterable
                :selectedLabel.sync="formData.reviewByName"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_reviewTime') || '审核日期'"
              prop="reviewTime"
            >
              <el-date-picker
                v-model="formData.reviewTime"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_remark') || '备注说明'"
              prop="remark"
            >
              <el-input
                v-model="formData.remark"
                type="textarea"
                :rows="3"
                clearable
                maxlength="500"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- Product Detail Table -->
    <detail-table
      ref="detailTable"
      :purchaseFabricCode="purchaseFabricCode"
      v-if="purchaseFabricCode"
    />
  </div>
</template>

<script>
import EditLoading from "@/mixins/edit-loading";
import DetailTable from "../detail-table/index.vue";

export default {
  mixins: [EditLoading],
  components: {
    DetailTable,
  },
  props: {
    purchaseFabricCode: String,
    disabled: Boolean,
    pageType: String,
  },
  data() {
    return {
      formData: {},
      rules: {},
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      if (!this.purchaseFabricCode) {
        // 新增时的初始数据
        this.formData = {
          purchaseDate: this.$moment().format("YYYY-MM-DD"),
        };
        this.$emit("loaded", this.formData);
        return;
      }

      this.loadingOpen();
      this.$api
        .purchaseFabricDetailApi({
          purchaseFabricCode: this.purchaseFabricCode,
        })
        .then((res) => {
          this.loadingClose();
          this.formData = res.body || {};
          this.$emit("loaded", this.formData);
        })
        .catch(() => {
          this.loadingClose();
        });
    },
    reloadTable() {
      if (this.$refs.detailTable) {
        this.$refs.detailTable.getData();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.content-section {
  background: #fff;
  padding: 18px;
}

.form-section {
  margin-bottom: 10px;
}

.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
}

.form-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.form-actions {
  display: flex;
  gap: 10px;
}
</style>
